<template>
    <div id="assetMessage" class="sc-message--text">
        <div class="media-content-wrapper">
            <a
                :href="getSrc()"
                download
                target="_blank"
            >
                <div v-if="message.raw.asset.ext" :class="`fi-${message.raw.asset.ext}`" class="fi">
                    <div class="fi-content">{{ message.raw.asset.ext }}</div>
                </div>
                <a-icon type="cloud-download" v-else />
                <p class="media-content-text" v-if="message.raw.asset.name">
                    {{ message.raw.asset.name }}
                </p>
                <p class="media-content-text" v-else>
                    {{ $t("message.download") }}
                </p>
            </a>
        </div>
        <span v-if="message.data.meta" class="sc-message--meta">{{ message.data.meta }}</span>
    </div>
</template>

<script>
export default {
    name: "AssetMessage",
    props: ["message"],
    methods: {
        getSrc() {
            const asset = this.message.raw.asset;
            const isApiMessages = asset.path && asset.path.indexOf("api-messages") !== -1;
            return asset.cdnUrl
                ? asset.cdnUrl
                : isApiMessages
                ? `https://static.supsis.live/${asset.path}`
                : `https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .media-content-wrapper {
        margin: 4px;

        a {
            display: flex;
            gap: 5px;
            flex-direction: row;
            align-items: center;
        }

        .media-content-text {
            margin-bottom: 0;
            margin-top: 4px;
            max-width: 100px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/AssetMessage.vue